import { AuthenticationContext } from "@/app/context/authentication/authenticationContext";
import {
    Button, Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text, Image,
    Box,
    Flex,
    VStack,
    Badge
} from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { useContext, useEffect, useState } from "react";
import { keyframes, css } from '@emotion/react';
import { LeaderboardEntryType, ZoneType } from "@/app/types/zoneType";
import { timeFormatterHelper } from "@/app/helpers/numberFormatterHelper";
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";
import { NotificationContext } from "@/app/context/notification/notificationContext";
import { inLeaderboardMessage } from "@/app/context/notification/helper/anaDiscussionHelper";
const zoomAndShake = keyframes`
   0% {
   -webkit-transform: scale(0.9);
    transform: scale(0.9);
    transform-origin: center;
    opacity: 0;
  }
  50% {
   -webkit-transform: scale(1.2);
    transform: scale(1.2);
    transform-origin: center;
    opacity: 1;
  }
  100% {
   -webkit-transform: scale(1);
    transform: scale(1);
    transform-origin: center;
    opacity: 1;
  }
`;

type Props = {
    isOpen: boolean;
    onClose: () => void;
    zoneId: string
};

export default function LeaderBoardModal({isOpen,onClose, zoneId}:Props) {

    const [zone, setZone] = useState<ZoneType | undefined>(undefined);
    const { t } = useTranslation();

    const {
        user
    }=useContext(AuthenticationContext);

    const {
        myZones,
    } = useContext(GlobalDataUserContext)

    const {
        addMessageWithId,
        character
    } = useContext(NotificationContext)

    useEffect(() => {
        if(zoneId && myZones){
            const zone = myZones.find((zone:ZoneType) => zone.id === zoneId);
            if(zone){
                setZone(zone);
            }
        }
    },[zoneId, myZones])

    useEffect(()=>{
        if ( isOpen && zone && zone.leaderboard && zone.leaderboard.length > 0){
            const isUserInLeaderboard = zone.leaderboard.find((leader:LeaderboardEntryType) => leader.userId === user?.uid);    
            if (isUserInLeaderboard){
                inLeaderboardMessage(addMessageWithId,t, character?.translationKey)
            }
        }
    },[zone, isOpen])

    return (
        <Modal isCentered  isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent maxH="80vh" overflow={"hidden"} m={5}  css={css`
                    animation: ${zoomAndShake} 0.7s ease-out;
                `}>
                <ModalHeader px={0} pt={2} pb={0} textAlign={"center"}>{t("game.leaderBoardZone")}</ModalHeader>
                <ModalCloseButton />
                <ModalBody px={2} pt={0} pb={2} overflow="auto">
                    {zone && zone.leaderboard && zone.leaderboard.length > 0 && zone.leaderboard.map((leader:any, index:number) => (    
                        <Flex key={index} alignItems="center" py={1} background={index % 2 != 0?"#bdbdbd26":"transparent"}>                                        
                            <Image borderRadius={"50%"} w="30px" h="30px" src={leader.userPhotoUrl} alt={leader.userName} />
                            <VStack alignItems="flex-start" px={2} gap={0} w="full">
                                <Text fontSize={"sm"} textOverflow="ellipsis" overflow=" hidden" whiteSpace="nowrap" lineHeight="1em" fontWeight={"bold"}>{leader.userName}</Text>
                                <Text fontSize={"sm"}>{timeFormatterHelper(leader.timestamp,0)}</Text>
                            </VStack>
                            <Badge bg="#2a9ce1" fontSize="lg" lineHeight="0.8em" color="white" borderRadius={"50%"} p={2} minW="30px" textAlign="center" h="30px">{index+1}</Badge>
                        </Flex> 
                    ))}
                    {!( zone && zone.leaderboard && zone.leaderboard.length > 0) && 
                        <Text fontSize="sm">{t("game.noLeaderboard")}</Text>
                    }
                </ModalBody>
                <ModalFooter px={2} pt={0} pb={2} display="flex">
                        <Button
                            background="#f16529" 
                            color="white"
                            onClick={onClose}
                            w="full"
                        >
                            {t("game.close")}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
    )

}